<template>
  <div>
    <p>1. Scan this QR code with your Google Authenticator App. Alternatively, you can use the code: <code>{{ secretKey }}</code></p>
    <img :src="'data:image/png;base64,' + qrCode" alt="qrcode">

    <p>2. Enter the pin from Google Authenticator app:</p>
    <div class="form-group">
      <label for="code" class="control-label" />
      <input
        id="code"
        v-model="code"
        type="password"
        class="form-control col-md-4"
        placeholder="Authenticator Code"
        name="code"
        required
      >
    </div>
    <button type="submit" class="btn btn-primary" @click="enableGoogle2fa">
      Enable 2FA
      <span v-if="loading" class="btn-loader" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'EnableGoogle2FA',

  props: {
    secretKey: {
      type: String,
      required: true,
    },
    qrCode: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    code: '',
    loading: false,
  }),

  methods: {
    isFormValid() {
      if (!this.code) {
        this.$emit('getErrors', 'Please pass Authenticator Code field.');
        return false;
      }
      return true;
    },
    enableGoogle2fa() {
      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      const postFormData = new FormData();
      postFormData.append('secret', this.code);
      this.$apiHttp.post(`${this.$config.app_api.host}${this.$config.app_api.prefix}2fa/enable`, postFormData)
        .then((response) => {
          if (response.data.success) {
            this.$emit('getErrors', null);
            const newValue = {
              ...JSON.parse(localStorage.getItem(this.$config.userStorage.name)),
              google2fa_enabled: true,
            };
            localStorage.setItem(this.$config.userStorage.name, JSON.stringify(newValue));
            this.$store.commit('user/setGoogle2faInfo', true);
          }
        })
        .catch((e) => {
          if (e.response) {
            this.$emit('getErrors', e.response.data.message);
          } else {
            this.$emit('getErrors', e.message);
            console.log('Error', e.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EnableGoogle2FA.vue?175e9d9f